import React , {createContext , useContext, useState } from 'react'

const PayoutByLinkContext = createContext()


const PayoutByLinkContextProvider = ({children})=>{

     const [ loader , setLoader ] = useState(true)
     const [ token , setToken ] = useState({})
     const [ currentPage , setCurrentPage ] = useState('')
    return (
         <PayoutByLinkContext.Provider value={{ token , setToken ,  loader , setLoader , setCurrentPage , currentPage }}>
            {children}
         </PayoutByLinkContext.Provider>
    )
}

export const usePayoutByLinkContext = ()=> useContext(PayoutByLinkContext)

export default PayoutByLinkContextProvider